<div class="status-rejected form-container">
  <img src="assets/icons/caution.svg" alt="Icono Rechazado" />
  <h4>Pago inconcluso</h4>
  <p>
    Se presentó un problema al realizar el pago. Por favor, revisa los datos ingresados e inténtalo
    nuevamente.
  </p>
  <div>
    <button class="btn-primary-bg" (click)="onKillPurchase()">Volver al comercio</button>
  </div>
</div>
